var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "w-input",
      class: [
        {
          focus: _vm.isFocused,
          filled: _vm.filled,
          required: _vm.required,
        },
      ].concat(_vm.inputFeedback.classes),
    },
    [
      _c(
        "div",
        { staticClass: "input-wrapper" },
        [
          _vm._t(
            "label",
            function () {
              return [
                _c(
                  "label",
                  [
                    _c("div", { staticClass: "label" }, [
                      _vm._v(_vm._s(_vm.label)),
                    ]),
                    _vm._t(
                      "default",
                      function () {
                        return [
                          _c(
                            "input",
                            _vm._g(
                              {
                                ref: "input",
                                attrs: { type: _vm.inputType },
                                domProps: { value: _vm.value },
                              },
                              _vm.listeners
                            )
                          ),
                        ]
                      },
                      null,
                      {
                        label: _vm.label,
                        inputType: _vm.inputType,
                        value: _vm.value,
                        listeners: _vm.listeners,
                      }
                    ),
                  ],
                  2
                ),
              ]
            },
            null,
            {
              label: _vm.label,
              inputType: _vm.inputType,
              value: _vm.value,
              listeners: _vm.listeners,
            }
          ),
          _c(
            "div",
            { staticClass: "input-actions" },
            [
              _c(
                "transition-group",
                { attrs: { name: "fade", mode: "out-in" } },
                _vm._l(_vm.inputActions, function (action) {
                  return _c("button", { staticClass: "input-action" })
                }),
                0
              ),
            ],
            1
          ),
        ],
        2
      ),
      _c("div", { staticClass: "bar", class: _vm.barClass }),
      _c(
        "transition",
        { attrs: { name: "fade", mode: "out-in", appear: "" } },
        [
          _vm.feedback || _vm.isValid === false
            ? _c(
                "div",
                {
                  key: _vm.inputFeedback.type,
                  staticClass: "feedback",
                  class: _vm.inputFeedback.classes,
                },
                [_vm._v(_vm._s(_vm.inputFeedback.message))]
              )
            : _vm._e(),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }